import voice1No from 'assets/sounds/no/sprak/sf-test-1.mp3';
import voice2No from 'assets/sounds/no/sprak/sf-test-2.mp3';
import voice3No from 'assets/sounds/no/sprak/sf-test-3.mp3';
import voice4No from 'assets/sounds/no/sprak/sf-test-4.mp3';
import voice5No from 'assets/sounds/no/sprak/sf-test-5.mp3';
import voice6No from 'assets/sounds/no/sprak/sf-test-6.mp3';
import voice7No from 'assets/sounds/no/sprak/sf-test-7.mp3';
import voice8No from 'assets/sounds/no/sprak/sf-test-8.mp3';
import voice9No from 'assets/sounds/no/sprak/sf-test-9.mp3';
import voice10No from 'assets/sounds/no/sprak/sf-test-10.mp3';
import voice11No from 'assets/sounds/no/sprak/sf-test-11.mp3';
import voice12No from 'assets/sounds/no/sprak/sf-test-12.mp3';
import voice13No from 'assets/sounds/no/sprak/sf-test-13.mp3';
import voice14No from 'assets/sounds/no/sprak/sf-test-14.mp3';
import voice15No from 'assets/sounds/no/sprak/sf-test-15.mp3';
import voice16No from 'assets/sounds/no/sprak/sf-test-16.mp3';
import voice17No from 'assets/sounds/no/sprak/sf-test-17.mp3';
import voice18No from 'assets/sounds/no/sprak/sf-test-18.mp3';
import voice19No from 'assets/sounds/no/sprak/sf-test-19.mp3';
import voice20No from 'assets/sounds/no/sprak/sf-test-20.mp3';
import voice21No from 'assets/sounds/no/sprak/sf-test-21.mp3';

import testImg1a from '../assets/TestImages/test1_1.png';
import testImg1b from '../assets/TestImages/test1_2.png';
import testImg1c from '../assets/TestImages/test1_3.png';
import testImg1d from '../assets/TestImages/test1_4.png';

import testImg2a from '../assets/TestImages/test2_1.png';
import testImg2b from '../assets/TestImages/test2_2.png';
import testImg2c from '../assets/TestImages/test2_3.png';
import testImg2d from '../assets/TestImages/test2_4.png';

import testImg3a from '../assets/TestImages/test3_1.png';
import testImg3b from '../assets/TestImages/test3_2.png';
import testImg3c from '../assets/TestImages/test3_3.png';
import testImg3d from '../assets/TestImages/test3_4.png';

import testImg4a from '../assets/TestImages/test4_1.png';
import testImg4b from '../assets/TestImages/test4_2.png';
import testImg4c from '../assets/TestImages/test4_3.png';
import testImg4d from '../assets/TestImages/test4_4.png';

import testImg5a from '../assets/TestImages/test5_1.png';
import testImg5b from '../assets/TestImages/test5_2.png';
import testImg5c from '../assets/TestImages/test5_3.png';
import testImg5d from '../assets/TestImages/test5_4.png';

import testImg6a from '../assets/TestImages/test6_1.png';
import testImg6b from '../assets/TestImages/test6_2.png';
import testImg6c from '../assets/TestImages/test6_3.png';
import testImg6d from '../assets/TestImages/test6_4.png';

import testImg7a from '../assets/TestImages/test7_1.png';
import testImg7b from '../assets/TestImages/test7_2.png';
import testImg7c from '../assets/TestImages/test7_3.png';
import testImg7d from '../assets/TestImages/test7_4.png';

import testImg8a from '../assets/TestImages/test8_1.png';
import testImg8b from '../assets/TestImages/test8_2.png';
import testImg8c from '../assets/TestImages/test8_3.png';
import testImg8d from '../assets/TestImages/test8_4.png';

import testImg9a from '../assets/TestImages/test9_1.png';
import testImg9b from '../assets/TestImages/test9_2.png';
import testImg9c from '../assets/TestImages/test9_3.png';
import testImg9d from '../assets/TestImages/test9_4.png';

import testImg10a from '../assets/TestImages/test10_1.png';
import testImg10b from '../assets/TestImages/test10_2.png';
import testImg10c from '../assets/TestImages/test10_3.png';
import testImg10d from '../assets/TestImages/test10_4.png';

import testImg11a from '../assets/TestImages/test11_1.png';
import testImg11b from '../assets/TestImages/test11_2.png';
import testImg11c from '../assets/TestImages/test11_3.png';
import testImg11d from '../assets/TestImages/test11_4.png';

import testImg12a from '../assets/TestImages/test12_1.png';
import testImg12b from '../assets/TestImages/test12_2.png';
import testImg12c from '../assets/TestImages/test12_3.png';
import testImg12d from '../assets/TestImages/test12_4.png';

import testImg13a from '../assets/TestImages/test13_1.png';
import testImg13b from '../assets/TestImages/test13_2.png';
import testImg13c from '../assets/TestImages/test13_3.png';
import testImg13d from '../assets/TestImages/test13_4.png';

import testImg14a from '../assets/TestImages/test14_1.png';
import testImg14b from '../assets/TestImages/test14_2.png';
import testImg14c from '../assets/TestImages/test14_3.png';
import testImg14d from '../assets/TestImages/test14_4.png';

import testImg15a from '../assets/TestImages/test15_1.png';
import testImg15b from '../assets/TestImages/test15_2.png';
import testImg15c from '../assets/TestImages/test15_3.png';
import testImg15d from '../assets/TestImages/test15_4.png';

import testImg16a from '../assets/TestImages/test16_1.png';
import testImg16b from '../assets/TestImages/test16_2.png';
import testImg16c from '../assets/TestImages/test16_3.png';
import testImg16d from '../assets/TestImages/test16_4.png';
import testImg16e from '../assets/TestImages/test16_5.png';
import testImg16f from '../assets/TestImages/test16_6.png';

import testImg17a from '../assets/TestImages/test17_1.png';
import testImg17b from '../assets/TestImages/test17_2.png';
import testImg17c from '../assets/TestImages/test17_3.png';
import testImg17d from '../assets/TestImages/test17_4.png';
import testImg17e from '../assets/TestImages/test17_5.png';
import testImg17f from '../assets/TestImages/test17_6.png';

import testImg18a from '../assets/TestImages/test18_1.png';
import testImg18b from '../assets/TestImages/test18_2.png';
import testImg18c from '../assets/TestImages/test18_3.png';
import testImg18d from '../assets/TestImages/test18_4.png';
import testImg18e from '../assets/TestImages/test18_5.png';
import testImg18f from '../assets/TestImages/test18_6.png';

import testImg19a from '../assets/TestImages/test19_1.png';
import testImg19b from '../assets/TestImages/test19_2.png';
import testImg19c from '../assets/TestImages/test19_3.png';
import testImg19d from '../assets/TestImages/test19_4.png';

import testImg20a from '../assets/TestImages/test20_1.png';
import testImg20b from '../assets/TestImages/test20_2.png';
import testImg20c from '../assets/TestImages/test20_3.png';
import testImg20d from '../assets/TestImages/test20_4.png';

import testImg21a from '../assets/TestImages/test21_1.png';
import testImg21b from '../assets/TestImages/test21_2.png';
import testImg21c from '../assets/TestImages/test21_3.png';
import testImg21d from '../assets/TestImages/test21_4.png';

import starterTesten from 'assets/sounds/no/3 13 Tulleord Starter testen.mp3';

export const starterTestenSound = starterTesten;

export const bytteLydenExample = {};

export const tutorialAssignment = {
	id: 1,
	choices: [
		{
			word: 'lys',
		},
		{
			word: 'lese',
		},
		{
			word: 'katt',
		},
		{
			isCorrect: true,
			word: 'kam',
		},
	],
};
export const assignment1 = [
	{
		id: 1,
		mainimg: '',
		mainSound: voice1No,
		order: ['d'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg1a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg1b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg1c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg1d,
					},
				],
			},
		],
	},
];
export const assignment2 = [
	{
		id: 2,
		mainImg: '',
		mainSound: voice2No,
		order: ['a'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg2a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg2b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg2c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg2d,
					},
				],
			},
		],
	},
];
export const assignment3 = [
	{
		id: 3,
		mainImg: '',
		mainSound: voice3No,
		order: ['c'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg3a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg3b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg3c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg3d,
					},
				],
			},
		],
	},
];
export const assignment4 = [
	{
		id: 4,
		mainImg: '',
		mainSound: voice4No,
		order: ['d'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg4a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg4b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg4c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg4d,
					},
				],
			},
		],
	},
];
export const assignment5 = [
	{
		id: 5,
		mainImg: '',
		mainSound: voice5No,
		order: ['b'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg5a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg5b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg5c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg5d,
					},
				],
			},
		],
	},
];
export const assignment6 = [
	{
		id: 6,
		mainImg: '',
		mainSound: voice6No,
		order: ['a'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg6a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg6b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg6c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg6d,
					},
				],
			},
		],
	},
];
export const assignment7 = [
	{
		id: 7,
		mainImg: '',
		mainSound: voice7No,
		order: ['c'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg7a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg7b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg7c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg7d,
					},
				],
			},
		],
	},
];
export const assignment8 = [
	{
		id: 8,
		mainImg: '',
		mainSound: voice8No,
		order: ['a'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg8a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg8b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg8c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg8d,
					},
				],
			},
		],
	},
];
export const assignment9 = [
	{
		id: 9,
		mainImg: '',
		mainSound: voice9No,
		order: ['d'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg9a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg9b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg9c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg9d,
					},
				],
			},
		],
	},
];
export const assignment10 = [
	{
		id: 10,
		mainImg: '',
		mainSound: voice10No,
		order: ['d'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg10a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg10b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg10c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg10d,
					},
				],
			},
		],
	},
];
export const assignment11 = [
	{
		id: 11,
		mainImg: '',
		mainSound: voice11No,
		order: ['a'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg11a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg11b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg11c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg11d,
					},
				],
			},
		],
	},
];
export const assignment12 = [
	{
		id: 12,
		mainImg: '',
		mainSound: voice12No,
		order: ['b'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg12b,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg12a,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg12c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg12d,
					},
				],
			},
		],
	},
];
export const assignment13 = [
	{
		id: 13,
		mainImg: '',
		mainSound: voice13No,
		order: ['d'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg13d,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg13b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg13c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg13a,
					},
				],
			},
		],
	},
];
export const assignment14 = [
	{
		id: 14,
		mainImg: '',
		mainSound: voice14No,
		order: ['c'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg14a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg14b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg14c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg14d,
					},
				],
			},
		],
	},
];
export const assignment15 = [
	{
		id: 15,
		mainImg: '',
		mainSound: voice15No,
		order: ['d'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg15a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg15b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg15c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg15d,
					},
				],
			},
		],
	},
];
/* export const assignment16 = [
	{
		id: 16,
		mainImg: '',
		mainSound: voice16No,
		order: ['b', 'd', 'a'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg16a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg16b,
					},
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg16c,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg16d,
					},
					{
						groupId: 5,
						currentClass: 'imgItem',
						word: 'e',
						img: testImg16e,
					},
					{
						groupId: 6,
						currentClass: 'imgItem',
						word: 'f',
						img: testImg16f,
					},
				],
			},
		],
	},
];
export const assignment17 = [
	{
		id: 17,
		mainImg: '',
		mainSound: voice17No,
		order: ['d', 'a', 'e'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg17a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg17b,
					},
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg17c,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg17d,
					},
					{
						groupId: 5,
						currentClass: 'imgItem',
						word: 'e',
						img: testImg17e,
					},
					{
						groupId: 6,
						currentClass: 'imgItem',
						word: 'f',
						img: testImg17f,
					},
				],
			},
		],
	},
];
export const assignment18 = [
	{
		id: 18,
		mainImg: '',
		mainSound: voice18No,
		order: ['f', 'a', 'e'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg18a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg18b,
					},
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg18c,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg18d,
					},
					{
						groupId: 5,
						currentClass: 'imgItem',
						word: 'e',
						img: testImg18e,
					},
					{
						groupId: 6,
						currentClass: 'imgItem',
						word: 'f',
						img: testImg18f,
					},
				],
			},
		],
	},
]; */

export const assignment16 = [
	{
		id: 16,
		mainImg: '',
		mainSound: voice19No,
		order: ['b'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg19a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg19b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg19c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg19d,
					},
				],
			},
		],
	},
];

export const assignment17 = [
	{
		id: 17,
		mainImg: '',
		mainSound: voice20No,
		order: ['a'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg20a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg20b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg20c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg20d,
					},
				],
			},
		],
	},
];

export const assignment18 = [
	{
		id: 18,
		mainImg: '',
		mainSound: voice21No,
		order: ['d'],
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						word: 'a',
						img: testImg21a,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						word: 'b',
						img: testImg21b,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						word: 'c',
						img: testImg21c,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						word: 'd',
						img: testImg21d,
					},
				],
			},
		],
	},
];
export const assignment22 = [
	{
		id: 19,
		mainImg: '',
		mainSound: voice19No,
		text: 'Byt /k/ med /r/',
		choices: [
			{
				word: 'lys',

				img: '',
			},
			{
				word: 'dør',

				img: '',
			},
			{
				word: 'pennal',

				img: '',
			},
			{
				word: 'bord',

				img: '',
			},
		],
	},
];

export const assignments = [
	{
		id: 2,
		mainImg: '',
		choices: [
			{
				word: 'modil',

				img: '',
			},
			{
				word: 'vuks',

				img: '',
			},
			{
				word: 'fålk',

				img: '',
			},
			{
				word: 'flynt',

				img: '',
			},
		],
	},
	{
		id: 3,
		mainimg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},
			{
				word: 'peano',

				img: '',
			},
			{
				word: 'knain',

				img: '',
			},
		],
	},
	{
		id: 4,
		mainImg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},
			{
				word: 'peano',

				img: '',
			},

			{
				word: 'brillter',

				img: '',
			},
		],
	},
	{
		id: 5,
		mainImg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},

			{
				word: 'knain',

				img: '',
			},
			{
				word: 'brillter',

				img: '',
			},
		],
	},
	{
		id: 6,
		mainImg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},

			{
				word: 'knain',

				img: '',
			},
			{
				word: 'brillter',

				img: '',
			},
		],
	},
];
